import FormsApp from 'FormsUI/FormsApp';
import PortalIdParser from 'PortalIdParser';

// Sets up the correct `window.hubspot.portal.id` var that hub-http needs.
PortalIdParser.get();
const formsApp = new FormsApp();
formsApp.bootstrap();

// @ts-expect-error why are we setting this on the window?
window.formsApp = formsApp;